import daysJs from "dayjs";
import utc from "dayjs/plugin/utc";
import TimeZone from "dayjs/plugin/timezone";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/ar";
daysJs.extend(relativeTime);
daysJs.extend(utc);
daysJs.extend(TimeZone);
class DateTime {
  static Lang = "en";
  static SetLang(NewLang) {
    DateTime.Lang = NewLang;
    daysJs.locale(NewLang);
  }
  static DaysJs(input = new Date()) {
    return daysJs.tz(input, "Africa/Cairo");
  }
  static HandleDate(dateValue, Hours = true) {
    let date;
    if (dateValue) {
      date = new Date(dateValue);
    } else {
      date = new Date();
    }
    const formattedDate = DateTime.DaysJs(date);
    if (!Hours) {
      return formattedDate.format("DD/MM/YYYY");
    }
    return formattedDate.format("DD/MM/YYYY hh:mm A");
  }
  static HandleChatDate(dateValue, DaysToShow = 7) {
    const now = DateTime.DaysJs();
    let date = dateValue ? new Date(dateValue) : new Date();
    const formattedDate = DateTime.DaysJs(date);
    const sevenDaysAgo = now.clone().subtract(DaysToShow, "days");
    if (formattedDate.isAfter(sevenDaysAgo)) {
      return formattedDate.fromNow();
    } else {
      return formattedDate.format("DD-MM-YYYY hh:mm A");
    }
  }
  // date With Format yyyy-MM-ddThh:mm:ss
  static HandleLocalDate(inputDateString) {
    const valid = inputDateString ? new Date(inputDateString) : new Date();
    const formattedDate = DateTime.DaysJs(valid).format("YYYY-MM-DDTHH:mm:ss");
    return formattedDate;
  }
  static HandleDateYMD(inputDateString) {
    const valid = inputDateString ? new Date(inputDateString) : new Date();
    const formattedDate = DateTime.DaysJs(valid).format("YYYY-MM-DD");
    return formattedDate;
  }
  static HandleDateDMY(inputDateString) {
    const valid = inputDateString ? new Date(inputDateString) : new Date();
    const formattedDate = DateTime.DaysJs(valid).format("DD-MM-YYYY");
    return formattedDate;
  }
}

export default DateTime;
